import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const tempPassword = () => {
  const a = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const v = crypto.getRandomValues(new Uint32Array(10));
  return "Legion-" + Array.from(v, (x) => a[x % a.length]).join("");
};

const when = (t) => (t ? new Date(t).toLocaleDateString() : "never");

export const LeaderRow = ({ u, me, onChange }) => {
  const [armed, setArmed] = useState(false);
  const isOwner = u.role === "owner";

  const reset = async () => {
    const pw = tempPassword();
    try { await api.post(`/leaders/${u.id}/reset`, { password: pw }); toast.success(`New temporary password for ${u.email}: ${pw}`, { duration: 20000, position: "bottom-right" }); onChange(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    if (!armed) { setArmed(true); setTimeout(() => setArmed(false), 5000); return; }
    try { await api.delete(`/leaders/${u.id}`); toast.success(`Removed ${u.email}.`); onChange(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="lg-card" style={{ padding: 12, marginBottom: 8 }} data-testid={`leader-row-${u.email}`}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <b style={{ marginRight: "auto" }}>{u.name || u.email}{u.id === me.id && " (you)"}</b>
        <span className="lg-badge" style={{ position: "static" }}>{isOwner ? "Owner" : "Leader"}</span>
      </div>
      <div style={{ fontSize: 12.5, color: "var(--muted)", marginTop: 4 }}>
        {u.email} · last sign-in {when(u.last_login)}{u.must_change && " · hasn't set their password yet"}
      </div>
      {!isOwner && (
        <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
          <button className="lg-btn ghost sm" onClick={reset} data-testid={`leader-reset-${u.email}`}>Reset password</button>
          <button className="lg-btn ghost sm" onClick={remove} data-testid={`leader-remove-${u.email}`}>{armed ? "Press again to remove" : "Remove"}</button>
        </div>
      )}
    </div>
  );
};
